module.exports = __webpack_public_path__ + "static/media/ic-help.a51a13af.svg";